<template>
  <div class="page-item">
    <MdScroll id="comment" :url="url" :filterData="filterData" @getList="getList">
      <div v-for="item in list" :key="item.Id" class="item">
        <div class="item-content">
          <FormworkOne :createTime="item.CreateTime" :hasIntroduction="false" :row="userInfo"></FormworkOne> 
          <div class="content">
              {{item.Content}}
          </div>          
          <FormworkTwo class="mart-15" :row="item"></FormworkTwo>        
        </div>      
      </div> 
      <EmptyPosition v-show="!list.length" type="comment"></EmptyPosition>           
    </MdScroll>

  </div>
</template>

<script>
import FormworkOne from '../components/formworkOne'
import FormworkTwo from '../components/formworkTwo'
import MdScroll from '@/components/mdScroll/mdScroll'
import EmptyPosition from '@/components/common/emptyPosition'
import behavior from '@/filter/behavior'
import { Cms } from '@/api'
export default {
  name: 'comment',
  components: { FormworkOne, FormworkTwo, MdScroll, EmptyPosition },
  data() {
    return {
      list: [],
      filterData: {
        UserId: this.$mdUtils.getUserInfo('Id'),
        PageIndex: 1,
        PageSize: 10
      },
      userInfo: {
        Author: this.$mdUtils.getUserInfo()
      },
      url: Cms.QueryCommentArticleByPage
    }
  },
  methods: {
    getList(list) {
      let _list = JSON.parse(JSON.stringify(list))
      this.list = _list.map(item => {
        item.CreateTime = behavior.timeDis(item.CreateTime)
        return item
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  position: relative;
  padding: 25px;
  left: 0;
  &::after {
    @include line;
  }
  align-items: flex-start;
  &-checked {
    position: relative;
    top: 15px;
    margin-right: 20px;
  }
  &-content {
    flex: auto;
  }
}

.content {
  line-height: 22px;
  padding: 20px 0;
  font-weight: 400;
  font-size: $font-size-big;
  border-bottom: 1px solid $gray;
}
</style>

